<template>
  <div
    class="user-themes d-flex"
    style="min-height: 0"
  >
    <UserAppearance
      class="pa-0 mb-4 large-scroll-track"
      style="
        border-radius: 4px;
        overflow-x: auto;
        background: var(--clr-black-1);
        --padding-left: 1rem;
        --clr-palettes-btns-back: var(--clr-black-1);
        max-width: 74rem;
      "
    />
  </div>
</template>

<script>
import UserAppearance from '@/components/Dialogs/UserSettingsDialog/UserAppearance'

export default {
  name: 'UserThemes',

  components: {
    UserAppearance,
  },
  data() {
    return {}
  },
}
</script>
<style lang="scss" scoped>
@media (max-width: 620px) {
  .user-themes {
    overflow: auto;
  }
}
</style>
